export default "__VITE_ASSET__29d685a9__"